<template>
        <Event :is-frame="true"/>

</template>

<script>
  import Event from '../components/Event'

  export default {
    data() {
      return {}
    },
    watch: {},
    computed: {},
    components: {
      Event
    },
    created: function () {

    },
    mounted: function () {
    },
    methods: {},
    name: 'FramePage'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
